export default {
  data() {
    return {};
  },
  created() {},
  watch: {},
  computed: {
    lang() {
      return this.$store.getters.lang;
    },
    textbooklet() {
      return this.$store.getters.textbooklet;
    },
  },
  methods: {
    getText(slug) {
      if (this.$store.getters.textbooklet) {
        return this.$store.getters.textbooklet[this.$store.getters.lang][slug];
      } else {
        return slug;
      }
    },
  },
};
